import { endCTAFlow } from 'actions/editor';
import {
  updateVideoCtaEnabled,
  updateVideoCtaMods,
  updateVideoCtaText,
  updateVideoCtaUrl,
} from 'actions/shareVideo';
import { updateVideoCtaCreator } from 'creators/shareVideo';

export function clearCTAWidgetState() {
  return dispatch => {
    dispatch(updateVideoCtaEnabled(false));
    dispatch(updateVideoCtaText(''));
    dispatch(updateVideoCtaUrl(''));
    dispatch(updateVideoCtaMods(null));

    dispatch(endCTAFlow());
  };
}

export function saveCTA() {
  return dispatch => {
    dispatch(updateVideoCtaEnabled(true));
    dispatch(updateVideoCtaCreator());
    dispatch(endCTAFlow());
  };
}
